module.exports = __webpack_public_path__ + "static/media/avatar-09.76775174.svg";